import React, {Component} from 'react';
import firebase from 'firebase/app';
import {Booth} from 'vexpo-components';
import Spinner from '../spinner/spinner';

/** @class ShowbagPreview
  * A component to display a prepared Showbag
  * @prop {string} identifier - a unique identifier for the stage
  * @prop {number} width - the width of the stage, in pixels
  * @prop {number} height - the height of the stage in pixels
  * @prop {object} layers - the stage's layers.
  */
export default class ShowbagPreview extends Component {
  /** @constructor
    * Creates a new instance of ShowbagPreview
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.dataRef = firebase.database()
      .ref(`expos/${this.props.expoID}/shows/${this.props.showID}/showbag`);
  }
  /** @method componentWillMount()
    * Loads the showbag data from Firebase and transforms
    * it for consumption by a Booth Vexpo Component.
    */
  componentWillMount() {
    this.dataRef.on('value', (snapshot) => {
      const data = snapshot.val();
      var showbag = {
        name: 'showbag',
        interior: data.background,
        contents: []
      }
      for(var key in data.contents) {
        var content = data.contents[key];
        if(content.published) {
          content.id = key;
          showbag.contents.push(content);
        }
      }
      this.setState({showbag: showbag});
    });
  }
  /** @method componentWillUnmount
    * Terminates the connection with the Firebase database
    */
  componentWillUnmount() {
    this.dataRef.off()
  }
  /** @method render
    * Renders the stage
    */
  render() {
    if(!this.state.showbag) return <Spinner />
    return (
      <Booth {...this.state.showbag} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/showbag-preview/showbag-preview.js